import { Component, effect, inject } from '@angular/core';
import { DisplayPackOptionsComponent } from 'src/app/shared/components/display-pack-options/display-pack-options.component';
import { Pack } from 'src/app/shared/model/pack';
import { CurrentUserService } from 'src/app/shared/services/current-user.service';

@Component({
  selector: 'app-billing',
  templateUrl: './billing.component.html',
  styleUrl: './billing.component.scss',
  imports: [DisplayPackOptionsComponent],
})
export class BillingComponent {
  currentUserService = inject(CurrentUserService);
  pack?: Pack;
  usedTrips?: number;
  usedUsers?: number;

  constructor() {
    effect(() => {
      this.pack = this.currentUserService.currentUser()?.company?.pack;
      this.usedTrips =
        this.currentUserService.currentUser()?.company?._count?.trips;
      this.usedUsers =
        this.currentUserService.currentUser()?.company?._count?.users;
    });
  }
}
